import styled from "styled-components"

export const StyledHero = styled.div`
  box-shadow: 0 0 16px ${(props) => props.theme.colors.darkGrey10};
  background-color: #FFF5CE;
  position: relative;
`

export const StyledHeroContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  ${(props) => props.theme.mixins.container}
  
  @media (min-width: ${(props) => props.theme.breakPoints.tablet}) {
    min-height: 540px;
  }
  `
export const StyledHeroCard = styled.div`
  position: relative;
  z-index: 1;

  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    margin: 64px 0;
  }
`
export const StyledHeroTitle = styled.h1`
  font-family: ${(props) => props.theme.fonts.circularBook};
  font-size: 80px;
  text-transform: uppercase;
  text-align: center;
  margin: 0 0 32px 0;

  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    font-size: 48px;
    margin: 0 0 16px 0;
  }
`

export const StyledHeroDescription = styled.p`
  margin: 0 auto;
  text-align: center;
  color: ${(props) => props.theme.colors.darkGrey};
  font-size: 22px;
  line-height: 26px;
  max-width: 70%;

  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    font-size: 16px;
    line-height: 20px;
    max-width: 100%;
  }
`

export const StyledHeroButtons = styled.div`
  margin: 32px 0 0;
  display: flex;
  justify-content: center;
  gap: 16px;
  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    margin: 24px 0 0;
  }

  & .button-v2--text {
    padding-top: 0;
    padding-bottom: 0;
    min-height: 0;
  }
`
export const StyledBgImg = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;

  & > div {
    height: 100%;
  }

  & img {
    width: 100%;
  }
`
